<script>
    export let context; context;
    import Image from '../components/Image.svelte';
</script>
<div>
    
    <section class="section container">
        <h1 class="title">
            About Us
        </h1>
        <div class="content">
            The Skill Tree Company aims to give kids the life skills to make them grounded, rounded, resilient young
            people who can reach their full potential. Our key themes are to raise self-esteem, encourage positivity,
            assertiveness and resilience. We will also teach how to combat bullying and learn to focus and relax, even
            during high stress times such as exam preparation. Our society vaccinates kids against potential physical
            diseases but does not protect them from stress and the pressures that fast paced 21 century living can
            bring. Often the techniques that can help children cope are only offered when a child is already in
            difficulty, e.g., being bullied or diagnosed with an emerging mental health problem. Our aim is to teach
            these valuable life skills, ideas and techniques early, to protect our children and help them grow into the
            young people they are meant to be. Parents ourselves, we have run the gauntlet of discovering our children
            are being bullied, or having to watch them struggle with the multitude of pressures we could not have
            conceived of in our own childhoods. Many of the approaches we have developed were conceived with highly
            sensitive young people in mind, then found to be more universally helpful and effective. We are both
            passionate about teaching kids the skills to relax, build resilience and enjoy life to the full. Our
            workshops offer an opportunity to build their confidence, whilst having some fun. With our combined skill
            sets covering teaching, course design, counselling and parenting skills, we have researched widely the ways
            in which kids can be helped to reach their full potential and find solutions to the many difficulties they
            face in everyday life at school, with their peers and within their families. We want to share this
            knowledge, offering skills for life, for everyone.
        </div>
        <div class="content has-text-centered">
            <span class="signature">Judith Algar-Nicholas</span>
            <span class="signature">Alison Williamson</span>
            <br/><br/>
            Co-founders of The Skill Tree Company
            <br/><br/>
            <Image src="/images/photoJCANAJSW.jpg" alt="The founders of the skill tree company"/>
              </div>
    </section>
</div>

<style>
    .signature {
        font-family: "Mistral", cursive;
        font-size: 24px;
        margin: 5px 50px;
    }
</style>